<template>
  <div>
    <notification-template
      :large="large"
      :hash="notification.id"
      :urlProfilePhoto="teacher.urlProfilePhoto"
    >
      <template v-slot:header>
        <h1 class="text-orange-academy-300">
          {{$t('notifications.teacher')}}
          {{$t('notifications.changeLesson')}}</h1>
      </template>
      <div>
        <p>
          {{$t('notifications.teacher')}}
          <router-link :to="`/teachers/${teacher.slug}`" class="font-medium">
            {{ teacher.name }}
          </router-link>
          {{$t('notifications.changeLesson')}} {{$t('notifications.from')}}
          <span class="font-bold uppercase">{{ formattedOldSlotStartDate }}</span>
          {{$t('notifications.to')}}
          <span class="font-bold uppercase">{{ formattedNewSlotStartDate }}</span>
        </p>
      </div>
      <template v-slot:actions>
        <div class="flex justify-center text-base" v-show="!isReplied">
          <button class="rounded-sm p-2 text-white mr-4 mt-4 uppercase bg-green-300 w-20
          hover:bg-green-500"
          @click="acceptNewLessonTime"
          >
            {{$t('notifications.accept')}}
          </button>
          <button class="rounded-sm p-2 text-white mt-4 uppercase
            bg-red-300 w-20 hover:bg-red-500"
          @click="rejectNewLessonTime"
          >
            {{$t('notifications.decline')}}
          </button>
        </div>
      </template>
    </notification-template>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import NotificationsMixin from '../../mixins/NotificationsMixin';
import NotificationTemplate from './NotificationTemplate.vue';

export default {
  components: {
    NotificationTemplate,
  },

  props: {
    notification: {
      type: Object,
      default: () => {},
    },
    large: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      teacher: { ...this.notification.data.teacher },
    };
  },
  computed: {
    isReplied() {
      return this.notification.replied_at !== null;
    },
  },
  mixins: [NotificationsMixin],
  methods: {
    ...mapActions({
      markAsReplied: 'notifications/markAsReplied',
      toggleNotifications: 'toggleNotifications',
    }),
    acceptNewLessonTime() {
      axios.put(`/api/slots/pending/${this.notification.data.new_slot.id}/${this.notification.data.old_slot.id}?accepted=true`)
        .then(() => {
          this.markAsReplied(this.notification);
          this.createNotification('success', this.$t('notifications.answerSentToTeacher'));
        }).catch(() => {
          this.createNotification('error', this.$t('notifications.errorTryAgain'));
        });
    },

    rejectNewLessonTime() {
      axios.put(`/api/slots/pending/${this.notification.data.new_slot.id}/${this.notification.data.old_slot.id}?accepted=false`)
        .then(() => {
          this.markAsReplied(this.notification);
          this.createNotification('success', this.$t('notifications.answerSentToTeacher'));
        }).catch(() => {
          this.createNotification('error', this.$t('notifications.errorTryAgain'));
        });
    },
    goToDashboard() {
      if (!this.large) {
        this.toggleNotifications();
        this.$router.push(`/teacher-dashboard#${this.notification.id}`).catch(() => {});
      }
    },
  },
};
</script>
